// Helpers y constantes del módulo Trips (Iteración 4).
export { fmtEUR, fmtUSD, fmtPct, PARTNER_LABELS } from "@/pages/motor/shared";

export const TRIP_STATUS_LABELS = {
  abierto: "Abierto",
  cotizaciones: "Cotizaciones",
  cerrado: "Cerrado",
  terminado: "Terminado",
  archivado: "Archivado",
  cancelado: "Cancelado",
  viaje_empresa: "Viaje de Empresa",
};

export const TRIP_STATUS_VARIANT = {
  abierto: "default",
  cotizaciones: "secondary",
  cerrado: "outline",
  terminado: "outline",
  archivado: "outline",
  cancelado: "destructive",
  viaje_empresa: "secondary",
};

export const SOURCES = [
  "KimKim", "Zicasso", "Baboo", "Responsible Travel", "Direct",
  "Repeat", "Referral", "Travel Agency", "Alkasa", "Ooh",
];

export const RESERVA_TYPE_LABELS = {
  alojamiento: "Alojamiento",
  actividad: "Actividad",
  entradas: "Entradas",
  transfer: "Transfer",
  tren: "Tren",
  vuelo: "Vuelo",
  rental_car: "Coche de alquiler",
  free_day: "Día libre",
  self_drive: "Self Drive",
  self_guided: "Self Guided",
  otros: "Otros",
  actividad_transporte: "Actividad", // legacy
};

export const RESERVA_STATUS_LABELS = {
  sin_seleccion: "No contactado (N)",
  contacto: "Contactado (C)",
  reserva: "Reservado (R)",
  confirmacion: "Re-confirmado (F)",
  cancelada: "Cancelada",
};

// Color de cada estado (clases tailwind para badges)
export const RESERVA_STATUS_CLASS = {
  sin_seleccion: "bg-muted text-muted-foreground",
  contacto: "bg-sky-100 text-sky-700",
  reserva: "bg-amber-100 text-amber-800",
  confirmacion: "bg-emerald-100 text-emerald-700",
  cancelada: "bg-rose-100 text-rose-700",
};

// Transiciones permitidas (espejo del backend models_trip.RESERVA_TRANSITIONS)
export const RESERVA_TRANSITIONS = {
  sin_seleccion: ["contacto", "reserva", "cancelada"],
  contacto: ["reserva", "cancelada", "sin_seleccion"],
  reserva: ["confirmacion", "cancelada", "contacto"],
  confirmacion: ["cancelada", "reserva"],
  cancelada: ["sin_seleccion", "contacto"],
};

export const RESERVA_OVERRIDE_LABELS = {
  no: "Estándar (markup)",
  kimkim: "KimKim",
  override_hotel: "Override hotel",
  override: "Override (precio manual)",
  "8%": "+8%",
};

export const RESERVA_FACTURACION_LABELS = {
  sin_factura: "Sin factura",
  factura: "Factura",
  factura_mensual: "Factura mensual",
  facturado_mensual: "Facturado mensual",
  no_aplica: "No aplica",
};

export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("es-ES") : "—");

// Cotizado de una reserva = coste s/IVA TOTAL del servicio; nunca se multiplica por unidades
// (Dirección, oct-2026). Misma regla que el backend (`_accounting`).
export const reservaQty = () => 1;
export const reservaCotizadoTotal = (r) => Math.round((Number(r?.cost_tax_excl) || 0) * 100) / 100;
